import { forwardRef } from 'react';
import MUIIconButton from '@material-ui/core/IconButton';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { CustomCircularProgress } from 'src/components/CustomCircularProgress';

import { CUSTOM_ICON_BUTTON_SIZE, CUSTOM_ICON_BUTTON_VARIANT, getFontSize } from './lib';
import { useStyles } from './useStyles';

const propTypes = {
  className: PropTypes.string,
  classes: PropTypes.shape({}),
  variant: PropTypes.oneOf(Object.values(CUSTOM_ICON_BUTTON_VARIANT)),
  size: PropTypes.oneOf(Object.values(CUSTOM_ICON_BUTTON_SIZE)),
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  children: PropTypes.node,
};

const defaultProps = {
  className: null,
  classes: null,
  variant: CUSTOM_ICON_BUTTON_VARIANT.default,
  size: CUSTOM_ICON_BUTTON_SIZE.medium,
  loading: false,
  disabled: false,
  children: null,
};

export const CustomIconButton = forwardRef(
  ({ className, classes, variant, size, loading, disabled, children, ...props }, ref) => {
    const styles = useStyles({ classes, variant, size });

    return (
      <MUIIconButton
        className={cx(styles.root, className, {
          [styles.loading]: loading,
        })}
        classes={{
          label: styles.label,
        }}
        disabled={disabled}
        ref={ref}
        {...props}
      >
        {children}
        {loading && (
          <CustomCircularProgress
            className={styles.spinner}
            size={getFontSize(size)}
          />
        )}
      </MUIIconButton>
    );
  }
);

CustomIconButton.propTypes = propTypes;
CustomIconButton.defaultProps = defaultProps;
